<template>
    <div class="nav_bar">
        <div :class="{ item: true, item_select: index == 0 }"
             @click.stop="touchItem(0,'/archives/dossier/log')">
            跟进日志
        </div>
        <div :class="{ item: true, item_select: index == 1 }"
             @click.stop="touchItem(1,'/archives/dossier/contract')">
            合同信息
        </div>
        <div :class="{ item: true, item_select: index == 2 }"
             @click.stop="touchItem(2,'/archives/survey/designinfo')">
            设计信息
        </div>
        <div :class="{ item: true, item_select: index == 3 }"
             @click.stop="touchItem(3,'/archives/construction/index')">
            施工进度
        </div>
        <div :class="{ item: true, item_select: index == 4 }"
             @click.stop="touchItem(4,'/archives/dossier/aftersale')">
            售后维保
        </div>
    </div>
</template>

<script>
export default {
    name: "DossierNavBar",
    props: {
        //账号id
        accountId: {
            type: String,
            default: '',
        },
        //项目id
        projectId: {
            type: String,
            default: '',
        },
        //合同id
        contractId: {
            type: String,
            default: '',
        },
        //高亮的索引
        index: {
            type: Number,
            default: 0,
        },
    },
    methods: {
        touchItem(i, path) {
            this.$emit('touchNav', {index: i})
            this.$router.replace({
                path: `${path}?account_id=${this.accountId}&project_id=${this.projectId}&contract_id=${this.contractId}`,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.nav_bar {
    width: 686px;
    height: 80px;
    background: #f9f9fb;
    display: flex;
    margin: 0 auto;
    border-radius: 16px;


    .item {
        flex: 1;
        text-align: center;
        font-size: 24px;
        font-family: PingFang SC-Regular, PingFang SC;
        color: #a3a3a3;
        line-height: 80px;
        position: relative;
    }

    .item_select {
        font-weight: bold;
        color: #0d53fc;
    }

    .item_select::after {
        content: "";
        width: 96px;
        height: 4px;
        background: #0d53fc;
        position: absolute;
        left: calc(50% - 48px);
        bottom: 0;
    }
}
</style>
